import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Gif from "./../../assets/loading-gif-png-5.gif";
import UploadGif from "./../../assets/output-onlinegiftools.gif";
import Box from "../../components/Box";
import { AuthContext } from "../../App";
import { Axios } from "../../config/axios.js";
import * as xlsx from "xlsx";
import SampleFile from "../../assets/samples/paygo_sample.xlsx"
import { FaRecycle, FaUserAlt } from "react-icons/fa"
import { BsCashStack, BsCash } from "react-icons/bs"
import "./dashboard.css";
const Dashboard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useContext(AuthContext);
    const [file, setFile] = useState();
    const [notFound, setNotFound] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [filtering, setFiltering] = useState(true);

    const [count, setCount] = useState("");
    const [sum, setSum] = useState("");
    const [pendingBalance, setPendingBalnce] = useState("");
    const [payGoBalance, setPayGoBalnce] = useState("");

    const [fiscalYearUnq, setFiscalYearUnq] = useState([]);
    const [fiscalYear, setFiscalYear] = useState("");
    const [monthUnq, setMonthUnq] = useState([]);
    const [month, setMonth] = useState("");
    const [entityUnq, setEntityUnq] = useState([]);
    const [entity, setEntity] = useState([]);

    useEffect(() => {
        const GetData = async () => {
            setFiltering(true);
            console.log(fiscalYear)
            await Axios.get(
                `/paygo/getAll?entity=${entity}&fiscalYear=${fiscalYear}&month=${month}`,
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
                .then(function (response) {
                    console.log(response);
                    if (response.data.length < 1) {
                        setNotFound(true);
                        setLoading(false);
                    } else {
                        setFiltering(false);
                        setNotFound(false);
                        setLoading(false);
                        console.log(response);
                        if (response.status === 200) {
                            setCount(response.data[0].myCount);
                            setSum(response.data[0].payment);
                            setPendingBalnce(response.data[0].pendingBalacne);
                            setPayGoBalnce(response.data[0].payGoBalance);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        };

        GetData();
    }, [entity, fiscalYear, month, user, user?.token]);

    useEffect(() => {
        const GetData = async () => {
            setFiltering(true);

            await Axios.get(`/paygo/getUniqueEntity`, {
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    if (response.status == 200) {
                        setEntityUnq(response.data);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

            await Axios.get(`/paygo/getFiscalYear`, {
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    if (response.status == 200) {
                        setFiscalYearUnq(response.data);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

            await Axios.get(`/paygo/getUniqueMonth`, {
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
            })
                .then(function (response) {
                    var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
                    if (response.status == 200) {
                        setMonthUnq(response.data.sort(collator.compare));
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        };

        GetData();
    }, [user?.token]);

    const UpdateData = async () => {
        setIsUploading(true);

        const reader = new FileReader();
        reader.onload = (e) => {
            // var data_chunks = [];
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);

            function chunkArray(myArray, chunk_size) {
                var index = 0;
                var arrayLength = myArray.length;
                var tempArray = [];
                for (index = 0; index < arrayLength; index += chunk_size) {
                    var myChunk = myArray.slice(index, index + chunk_size);
                    tempArray.push(myChunk);
                }
                return tempArray;
            }

            var result = chunkArray(json, 30000);
            console.log(result);

            result.forEach(async (v, i) => {
                await Axios.post(`/paygo/uploadAll`, v, {
                    // headers: {
                    //     Authorization: `Bearer ${user?.token}`,
                    // },
                })
                    .then(function (response) {
                        console.log(response);
                        if (result.length === i + 1) {
                            setIsUploading(false);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        alert("An Error Occured");
                    });
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const EarseData = async () => {
        setIsDeleting(true);
        await Axios.delete(`/paygo/deleteAll`, {
            // headers: {
            //     Authorization: `Bearer ${user?.token}`,
            // },
        })
            .then(function (response) {
                console.log(response);
                setIsDeleting(false);
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    let getMonthName = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);

        // Using the browser's default locale.
        return date.toLocaleString([], { month: 'short' });
    }
    return (
        <div>
            {loading ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "200px",
                    }}
                >
                    <img src={Gif} alt="" width="150px" />
                    <h1>Loading....</h1>
                </div>
            ) : (
                <section className="update_container">
                            <h3>Welcome to PayGo Details</h3>
                  
                   
                    <div className="filter">

                        <Select
                            onChange={(selectedOption) => setEntity(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...entityUnq.map((t) => ({ value: t, label: t })),
                            ]}
                            placeholder="Agency"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "320px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />


                        <Select
                            onChange={(selectedOption) => setFiscalYear(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...fiscalYearUnq.map((t) => ({ value: t, label: t })),
                            ]}
                            placeholder="Fiscal Year"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "280px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />
                        <Select
                            onChange={(selectedOption) => setMonth(selectedOption.value)}
                            options={[
                                { value: "", label: "Get All" },
                                ...monthUnq.map((t) => ({ value: t, label: getMonthName(t) })),
                            ]}
                            placeholder="Month"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles, backgroundColor: "#f2f2f2",
                                    borderRadius: '15px', backgroundColor: "#f2f2f2",
                                    borderRadius: '15px',
                                    width: "280px",
                                    "@media (max-width: 768px)": {
                                        width: '270px'
                                    }
                                }),
                            }}
                        />
                    </div>

                    {notFound ? (
                        <div>No Record Found</div>
                    ) : (
                        <div className="box_container">
                            {/* <Box value={count} title="Quantity" loading={filtering} /> */}
                            <Box
                                value={sum?.toLocaleString("en-US") || "Loading.."}
                                title="Payment:"
                                loading={filtering}
                                icon={<BsCash color='#fff' size='34' />}

                            />
                            <Box
                                value={pendingBalance?.toLocaleString("en-US") || "Loading.."}
                                title="Pending Balance:"
                                loading={filtering}
                                icon={<BsCashStack color='#fff' size='34' />}

                            />
                            <Box
                                value={payGoBalance?.toLocaleString("en-US") || "Loading.."}
                                title="PayGo:"
                                loading={filtering}
                            />
                        </div>
                    )}
                </section>
            )}
        </div>
    );
};

export default Dashboard;
